/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnUserGender } from './en-user-gender';
import { EnUserType } from './en-user-type';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface MemberDto
 */
export interface MemberDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof MemberDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof MemberDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof MemberDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof MemberDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof MemberDto
     */
    firstName: string;

    /**
     * @type {string}
     * @memberof MemberDto
     */
    lastName: string;

    /**
     * @type {string}
     * @memberof MemberDto
     */
    fiscalCode: string;

    /**
     * @type {string}
     * @memberof MemberDto
     */
    email: string;

    /**
     * @type {string}
     * @memberof MemberDto
     */
    dateOfBirth?: string | null;

    /**
     * @type {number}
     * @memberof MemberDto
     */
    height?: number | null;

    /**
     * @type {number}
     * @memberof MemberDto
     */
    weight?: number | null;

    /**
     * @type {EnUserGender}
     * @memberof MemberDto
     */
    gender?: EnUserGender | null;

    /**
     * @type {boolean}
     * @memberof MemberDto
     */
    verified: boolean;

    /**
     * @type {JoinEntityDto}
     * @memberof MemberDto
     */
    client: JoinEntityDto;

    /**
     * @type {EnUserType}
     * @memberof MemberDto
     */
    type?: EnUserType;

    /**
     * @type {Array<JoinEntityDto>}
     * @memberof MemberDto
     */
    authorities?: Array<JoinEntityDto>;

    /**
     * @type {string}
     * @memberof MemberDto
     */
    note?: string | null;

    /**
     * Timestamp of member self-service account deletion — null when deleted by an admin or not deleted
     *
     * @type {string}
     * @memberof MemberDto
     */
    selfDeletedAt: string | null;

    /**
     * @type {number}
     * @memberof MemberDto
     */
    education?: number | null;
}
